export const HOMEOWNER_AUDIENCE = 'homeowners'
export const BUYER_AUDIENCE = 'buyers'
export const RIPE_FOR_REFI_AUDIENCE = 'ripe-for-refi'
